import GlobalMap from '@routes/map/-globalMapView';
import LocalMap from '@routes/map/-localMap';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/map/')({
  component: MapPage,
});

function MapPage() {
  const { locationId = '' } = Route.useSearch();

  if (locationId) {
    return <LocalMap />;
  }

  return <GlobalMap />;
}
